import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const RulerIcon = (props) => (
  <SvgIcon viewBox="0 0 22 21" {...props}>
    <title>Ruler On</title>
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Custom-Preset" transform="translate(-1.000000, -1.000000)">
        <g
          id="Group"
          transform="translate(12.000000, 11.500000) rotate(49.000000) translate(-12.000000, -11.500000) translate(8.000000, 1.000000)"
        >
          <rect id="Rectangle" stroke="#000000" x="0.5" y="0.5" width="7" height="20" />
          <line
            x1="1.5"
            y1="4.5"
            x2="1.5"
            y2="4.5"
            id="Line-3"
            stroke="#979797"
            strokeLinecap="square"
          />
          <line
            x1="1.5"
            y1="4.5"
            x2="2.5"
            y2="4.5"
            id="Line-4"
            stroke="#000000"
            strokeLinecap="square"
          />
          <line
            x1="1.5"
            y1="2.5"
            x2="3.5"
            y2="2.5"
            id="Line-2"
            stroke="#000000"
            strokeLinecap="square"
          />
          <line
            x1="1.5"
            y1="6.5"
            x2="3.5"
            y2="6.5"
            id="Line-5"
            stroke="#000000"
            strokeLinecap="square"
          />
          <line
            x1="1.5"
            y1="8.5"
            x2="1.5"
            y2="8.5"
            id="Line-6"
            stroke="#979797"
            strokeLinecap="square"
          />
          <line
            x1="1.5"
            y1="8.5"
            x2="2.5"
            y2="8.5"
            id="Line-7"
            stroke="#000000"
            strokeLinecap="square"
          />
          <line
            x1="1.5"
            y1="10.5"
            x2="3.5"
            y2="10.5"
            id="Line-8"
            stroke="#000000"
            strokeLinecap="square"
          />
          <line
            x1="1.5"
            y1="12.5"
            x2="2.5"
            y2="12.5"
            id="Line-9"
            stroke="#000000"
            strokeLinecap="square"
          />
          <line
            x1="1.5"
            y1="14.5"
            x2="3.5"
            y2="14.5"
            id="Line-10"
            stroke="#000000"
            strokeLinecap="square"
          />
          <line
            x1="1.5"
            y1="16.5"
            x2="2.5"
            y2="16.5"
            id="Line-11"
            stroke="#000000"
            strokeLinecap="square"
          />
          <line
            x1="1.5"
            y1="18.5"
            x2="3.5"
            y2="18.5"
            id="Line-12"
            stroke="#000000"
            strokeLinecap="square"
          />
        </g>
      </g>
    </g>
  </SvgIcon>
);

export default RulerIcon;
